// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__8kICL","title":"popup_title__iBMkt","btn":"popup_btn__fZdrU","close_btn":"popup_close_btn__QqZL3"};